import {
  useRequest as useApiRequest,
  UseRequest,
  AxiosError,
} from "@stemscopes/api";

const shouldCancel = (method: string): boolean =>
  !["patch", "put", "post", "delete"].includes(method.toLowerCase());

const useRequest = <
  TData = undefined,
  TMeta = { pagination: { count: number } },
  TError = AxiosError,
>({
  method = "get",
  ...options
}: Parameters<UseRequest<TData, TMeta, TError>>[0]): ReturnType<
  UseRequest<TData, TMeta, TError>
> =>
  useApiRequest({ method, cancelOnUnmount: shouldCancel(method), ...options });

export default useRequest;
